import React from 'react';
import { useTranslation } from 'react-i18next';
import { Brain, CheckCircle2, MessageSquare, FileText, Clock } from 'lucide-react';

const CARDS = [
  { key: 'total', icon: Brain, color: 'text-primary-600 bg-primary-50' },
  { key: 'approved', icon: CheckCircle2, color: 'text-green-600 bg-green-50' },
  { key: 'from_tickets', icon: MessageSquare, color: 'text-blue-600 bg-blue-50' },
  { key: 'from_documents', icon: FileText, color: 'text-purple-600 bg-purple-50' },
  { key: 'awaiting_embedding', icon: Clock, color: 'text-amber-600 bg-amber-50' },
];

export default function KnowledgeStats({ stats }) {
  const { t } = useTranslation();

  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
      {CARDS.map(({ key, icon: Icon, color }) => (
        <div key={key} className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${color}`}>
              <Icon className="h-4 w-4" />
            </div>
            <div className="min-w-0">
              <p className="text-2xl font-bold text-gray-900 leading-tight">{stats[key] ?? 0}</p>
              <p className="text-xs text-gray-500 truncate">{t(`knowledge.stat_${key}`)}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
